import React from "react";
import styled from "styled-components";

import SectionWrapper from '../UI/SectionWrapper';

import appDev from "../../../Assets/whatweoffer/app-development.jpg";
import businessSolutions from "../../../Assets/whatweoffer/business-focussed-tech-solutions.jpg";
import digitalTransformation from "../../../Assets/whatweoffer/digital-transformation.jpg";
import techLeadership from "../../../Assets/whatweoffer/technology-leadership.jpg";
import { COLORS } from "../../../Constants/colors";


const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  width: 100%;
  box-sizing: border-box;
`;

const LeftSection = styled.div`
  flex-basis: 40%;
  max-width: 40%;
  box-sizing: border-box;
  border-radius: 10px;
  background: ${COLORS.specialBG};
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  min-width: 0;

  @media (max-width: 1200px) {
    flex-basis: 100%;
    max-width: 100%;
    order: 2;
  }
`;

const RightSection = styled.div`
  flex-basis: 60%;
  max-width: 60%;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding-left: 1rem;
  min-width: 0;

  @media (max-width: 1200px) {
    flex-basis: 100%;
    max-width: 100%;
    order: 1;
    margin-bottom: 20px;
    padding: 0;
  }
`;

const ServiceItem = styled.div``;

const ServiceTitle = styled.h3`
  color: ${COLORS.buttonText};
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  font-weight: 800;

`;

const ServiceDesc = styled.p`
  color: ${COLORS.textPrimary};
  font-size: 1.1rem;
  margin: 0;
  font-weight: 800;
  line-height: 1.5;
`;

const Box = styled.div`
  flex: 1 1 calc(50% - 0.5rem);
  background-color: ${({ bg }) => COLORS[bg] || COLORS.cardBackground};
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 0 8px ${COLORS.shadowColor};

  a {
    text-decoration: none;
    color: inherit;
    display: block;
  }
`;

// const ImageBox = styled.div`
//   position: relative;
//   width: 100%;
//   height: 100%;
//   min-height: 300px;
//   border-radius: 10px;
//   background-image: ${({ image }) =>
//     `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${image})`};
//   background-size: cover;
//   background-position: center;
//   display: flex;
//   align-items: flex-start;
//   justify-content: flex-start;
//   padding: 12px;
//     &::before {
//     content: "";
//     position: absolute;
//     inset: 0;
//     background-image: ${({ image }) =>
//       `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${image})`};
//     background-size: cover;
//     background-position: center;
//     transition: transform 0.4s ease;
//     will-change: transform;
//     z-index: 1;
//   }

//   &:hover::before {
//     transform: scale(1.05);
//   }
//   @media (max-width: 600px) {
//     padding: 30px 4px;
//     font-size: 1.2rem;
//      min-height: 200px;
//   }
// `;

const ImageBox = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 300px;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    transition: transform 0.4s ease;
    will-change: transform;
    z-index: 1;
    brightness: 0.9
  }
  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background:  linear-gradient(
      rgba(0, 0, 0, 0.3),
      rgba(0, 0, 0, 0)
    );
    z-index: 2;
  }


  &:hover img {
    transform: scale(1.05);
  }

  @media (max-width: 600px) {
    min-height: 200px;
  }
`;

// const OverlayText = styled.div`
//   position: absolute;
//   top: 12px;
//   left: 12px;
//   background-color: ${COLORS.shadowColor};
//   color: ${COLORS.textPrimary};
//   padding: 6px 12px;
//   border-radius: 6px;
//   font-size: 1.6rem;
//   font-weight: 600;
//   z-index: 2;
//   max-width: 80%;
//   @media (max-width: 600px) {
//     font-size: 1.0rem;
//   }

// `;

const OverlayText = styled.div`
  color: ${COLORS.buttonText};
  z-index: 2;
  padding: 30px 12px;
  border-radius: 6px;
  font-size: 1.8rem;
  font-weight: 900;
  max-width: 80%;
  @media (max-width: 600px) {
    padding: 30px 0px;
    font-size: 1.2rem;
}
`;

const TextBox = styled.div`
  padding: 1rem;

  p {
    font-weight: 500;
    margin: 0;
  }
`;

function WhatWeOfferSection({ services, rightCards }) {
  return (
    <Wrapper>
      <LeftSection>
        {services.map((item, index) => (
          <ServiceItem key={index}>
            <ServiceTitle>{item.title}</ServiceTitle>
            <ServiceDesc>{item.description}</ServiceDesc>
          </ServiceItem>
        ))}
      </LeftSection>

      <RightSection>
        {rightCards.map((card, i) => (
          <Box key={i} bg={card.bg}>
            {/* <a href={card.link} title={card.title}> */}
              <ImageBox>
              <img src={card.image} alt={card.title} />
              <OverlayText>{card.title}</OverlayText>
                {/* <img src={card.image} alt={card.title} /> */}
              </ImageBox>
            {/* </a> */}
          </Box>
        ))}
      </RightSection>
    </Wrapper>
  );
}

const services = [
  {
    title: "Application Development",
    description: "Building scalable solutions from small apps to enterprise-grade systems.",
  },
  {
    title: "Business-Focused Tech Solutions",
    description: "Crafting technology strategies to solve real-world business problems.",
  },
  {
    title: "Digital Transformation",
    description: "Upgrading legacy systems with modern, future-ready technologies.",
  },
  {
    title: "Technology Leadership",
    description: "Advising corporate clients with strategic technology insights.",
  },
  {
    title: "System Support & Enhancement",
    description: "Ongoing maintenance, updates, and improvements to existing systems.",
  },
  {
    title: "System Integration",
    description: "Seamlessly connecting applications with third-party tools and platforms.",
  },
  {
    title: "Development Resource Staffing",
    description: "Providing skilled resources based on customer demands.",
  },
  {
    title: "Quality Assurance Services",
    description: "Ensuring software quality through robust testing and validation.",
  }
];

const rightCards = [
  {
    title: "Application Development",
    link: "",
    image: appDev,
    bg: "cardBackground"
  },
  {
    title: "Business-Focused Tech Solutions",
    link: "",
    image: businessSolutions,
    bg: "cardBackground"
  },
  {
    title: "Digital Transformation",
    link: "",
    image: digitalTransformation,
    bg: "backgroundLight"
  },
  {
    title: "Technology Leadership",
    link: "",
    image: techLeadership,
    bg: "cardBackground"
  }
];

export default function WhatWeOffer() {
  return (
    <SectionWrapper heading="WHAT WE OFFER?">
      <WhatWeOfferSection services={services} rightCards={rightCards} />
    </SectionWrapper>
  );
}
